(function () {
  if (window.AxiomMobileImagePriorityLoaded) return;
  window.AxiomMobileImagePriorityLoaded = true;

  var MOBILE_MEDIA_QUERY = '(max-width: 767px)';
  var LAZY_IMAGE_SELECTOR = 'img[loading="lazy"]';
  var mobileMediaQuery = window.matchMedia ? window.matchMedia(MOBILE_MEDIA_QUERY) : null;
  var observer = null;

  function isMobileViewport() {
    return Boolean(mobileMediaQuery && mobileMediaQuery.matches);
  }

  function isEligible(image) {
    return image
      && image.matches(LAZY_IMAGE_SELECTOR)
      && image.dataset.mobileImagePriority !== 'true'
      && !image.complete
      && !image.closest('[hidden], [aria-hidden="true"], template');
  }

  function promote(image) {
    if (!isEligible(image)) return;

    image.dataset.mobileImagePriority = 'true';
    // Safari's native lazy-load threshold is browser controlled. Promote media
    // before it reaches the viewport so decoding does not compete with scrolling.
    image.loading = 'eager';
    image.setAttribute('loading', 'eager');
    if (observer) observer.unobserve(image);
  }

  function ensureObserver() {
    if (observer || !('IntersectionObserver' in window)) return observer;

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) promote(entry.target);
      });
    }, {
      rootMargin: '0px 0px 125% 0px'
    });

    return observer;
  }

  // The observer sees what a box test cannot: images that are not rendered
  // (display: none) and images scrolled out of a horizontal slider never
  // intersect, so only media the shopper can reach by scrolling down load early.
  function observeImage(image) {
    if (!isEligible(image)) return;

    var imageObserver = ensureObserver();
    if (imageObserver) imageObserver.observe(image);
  }

  function initialize(scope) {
    if (!isMobileViewport()) return;

    var root = scope instanceof Element ? scope : document;
    if (root.matches && root.matches(LAZY_IMAGE_SELECTOR)) observeImage(root);
    root.querySelectorAll(LAZY_IMAGE_SELECTOR).forEach(observeImage);
  }

  function handleViewportChange(event) {
    if (event.matches) {
      initialize(document);
      return;
    }

    if (observer) {
      observer.disconnect();
      observer = null;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); }, { once: true });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  document.addEventListener('axiom:recommendations:loaded', function (event) { initialize(event.target); });

  if (mobileMediaQuery) {
    if (typeof mobileMediaQuery.addEventListener === 'function') {
      mobileMediaQuery.addEventListener('change', handleViewportChange);
    } else if (typeof mobileMediaQuery.addListener === 'function') {
      mobileMediaQuery.addListener(handleViewportChange);
    }
  }
})();
